import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FaqAccordion = ({ faqs, testid = "faq-accordion" }) => (
  <Accordion type="single" collapsible data-testid={testid} className="w-full space-y-3">
    {faqs.map((f, i) => (
      <AccordionItem
        key={f.q}
        value={`faq-${i}`}
        data-testid={`faq-item-${i + 1}`}
        className="rounded-2xl border border-slate-100 bg-white px-6 shadow-[0_8px_30px_rgb(0,0,0,0.04)]"
      >
        <AccordionTrigger data-testid={`faq-question-${i + 1}`} className="text-left font-display font-semibold text-brand-charcoal hover:text-brand-teal hover:no-underline py-5">
          {f.q}
        </AccordionTrigger>
        <AccordionContent data-testid={`faq-answer-${i + 1}`} className="text-sm sm:text-base text-slate-600 leading-relaxed pb-5">
          {f.a}
        </AccordionContent>
      </AccordionItem>
    ))}
  </Accordion>
);

export default FaqAccordion;
